// extracted by css-extract-rspack-plugin
export default {"footerWrapper":"Footer_footerWrapper__sKUyE","logo":"Footer_logo__lw9YT","footerLink":"Footer_footerLink__wqLEV"};